// extracted by mini-css-extract-plugin
export default {"triggerBtn":"TripleDotPoperMenu_triggerBtn__MYUsv","menuContent":"TripleDotPoperMenu_menuContent__jtRDQ","menuItem":"TripleDotPoperMenu_menuItem__q51TH"};